import { isEmail, isPassword, isPhone, isText } from './FormValidation';

export function isPublicRegistrationEnabled(): boolean {
    return process.env.VUE_APP_PUBLIC_REGISTRATION_ENABLED === 'true';
}

export function isPublicRegistrationValid(payload: Record<string, unknown>): boolean {
    return isText(payload.organisationName, 5, 255) && isText(payload.userName, 5, 255)
        && isPhone(payload.phone) && isEmail(payload.email) && isPassword(payload.password);
}
export function publicLanguages(configuration?: string, defaultLanguage?: string): Array<{ id: string; name: string }> {
    const ids = Array.from(new Set((configuration || defaultLanguage || 'en').split(',').map(value => value.trim())))
        .filter(value => ['en', 'ru'].includes(value));
    if (!ids.length) ids.push(['en', 'ru'].includes(defaultLanguage || '') ? String(defaultLanguage) : 'en');
    return ids.map(id => ({ id, name: id.toUpperCase() }));
}
